import { request } from '@/sdk/oauth'
import { Service, CarePlan } from '@/store/defintions/types'
import InsuranceCompany from '@/store/defintions/types/InsuranceCompany'

export async function getGenderDefinitions(): Promise<string[]> {
  const { data } = await request.get(
    '/definition/service-request/caregiver-genders',
  )
  return data
}

export function getServicesDefinitions(): Promise<Service[]> {
  return request
    .get('/definition/service-request/booking-services')
    .then(response => response.data)
}

export function getRejectReasonsDefinitions(): Promise<string[]> {
  return request
    .get('/definition/contract/rejection-reasons')
    .then(response => response.data)
}

export function getCarePlanDefinitions(): Promise<CarePlan[]> {
  return request
    .get('/definition/service-request/pricing-plans')
    .then(response => response.data)
}

export async function getInsuranceCompaniesDefinitions(): Promise<
  InsuranceCompany[]
> {
  const { data } = await request.get(
    '/definition/insurance/insurance-companies',
  )

  return data
}
